import React from 'react';
import { portal, Portal } from '../../../../../../Configs/general';

import MultipleLoadGDC from './MultipleLoad.GDC';

const MultipleLoad = props => {
  switch (portal) {
    case Portal.Gascaribe:
    case Portal.Gasguajira:
    case Portal.Efigas:
      return <MultipleLoadGDC {...props} />;
    default:
      return <></>;
  }
};

export default MultipleLoad;
